import { g as l } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as r, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconCalendarOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = l();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], h = ["clip-path"], u = /* @__PURE__ */ a("path", { d: "M4.75 1.5a.5.5 0 0 0 0 1H7.5V3a.5.5 0 0 0 1 0v-.5h1a.5.5 0 0 1 .5.5v1.5H7.75a.5.5 0 0 0 0 1H10v2.25a.5.5 0 0 0 1 0V3a1.5 1.5 0 0 0-1.5-1.5h-1V1a.5.5 0 0 0-1 0v.5H4.75Z" }, null, -1), f = /* @__PURE__ */ a("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.501 11.5a1.5 1.5 0 0 0 .95-.342l.195.196a.5.5 0 0 0 .708-.708l-10-10a.5.5 0 1 0-.708.708l.707.706-.112.126A1.5 1.5 0 0 0 1 3v7a1.5 1.5 0 0 0 1.5 1.5h7.001ZM2 10a.5.5 0 0 0 .5.5h6.999c.082 0 .163-.02.235-.06L4.793 5.5H2V10Zm0-5.5V3a.5.5 0 0 1 .06-.234L3.792 4.5H2Z"
}, null, -1), p = [
  u,
  f
], m = ["id"], v = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), g = [
  v
];
function H(e, I, d, b, q, t) {
  return r(), n("svg", {
    "aria-label": d.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--calendar-off"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Calendar Off",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      fill: "currentColor"
    }, p, 8, h),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, g, 8, m)
    ])
  ], 10, _);
}
const w = /* @__PURE__ */ s(c, [["render", H]]);
export {
  w as default
};
//# sourceMappingURL=calendar-off.js.map
